import React from 'react';
import {Route, Routes} from "react-router-dom";
import AllProducts from "./allproducts/AllProducts";

import './stocks.css';
const Stocks = () => {
    return (
        <div className={"homy_products_page"}>
            <Routes>
                <Route path="/*"  element={<AllProducts/>} />
            </Routes>
        </div>
    );
};

export default Stocks;